import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const Moon = forwardRef<Ref, IconPropsType>(
  ({ color = "currentColor", size, className, onClick }, ref) => (
    <svg
      ref={ref}
      className={className}
      onClick={onClick}
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
    </svg>
  ),
);

export default Moon;
